import { OfflineStatus } from "@/components/offline";
import { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { MobileFooter } from "./components/MobileFooter";
import { MobileHeader } from "./components/MobileHeader";
import { UpdatePrompt } from "./components/UpdatePrompt";

export function MobileLayout({ children }: PropsWithChildren) {
  const location = useLocation();

  return (
    <>
      <OfflineStatus />
      <ErrorBoundary resetKey={location.pathname}>
        <div className="flex flex-col min-h-screen">
          <MobileHeader className="border-b border-slate-200" />
          <div className="p-2 flex flex-col flex-1">
            <main className="pb-16 flex flex-1 flex-col">
              <UpdatePrompt />
              {children}
            </main>
            <MobileFooter className="z-50 border-t border-white bg-white/30 backdrop-blur-sm h-16 fixed bottom-0 right-0 left-0" />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
